import { render, staticRenderFns } from "./physicalExaminationDetail.vue?vue&type=template&id=3974107a&scoped=true"
import script from "./physicalExaminationDetail.vue?vue&type=script&lang=js"
export * from "./physicalExaminationDetail.vue?vue&type=script&lang=js"
import style0 from "./physicalExaminationDetail.vue?vue&type=style&index=0&id=3974107a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3974107a",
  null
  
)

export default component.exports